var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"value":_vm.value,"items":_vm.lead_types,"loading":_vm.loading,"item-text":"description","item-value":"id"},on:{"input":_vm.handleInput,"focus":function($event){return _vm.loadItems()}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }